// src/components/FormattedCurrency.jsx
import React from "react";

export default function FormattedCurrency({ value, currency = "USD", locale = navigator.language || "en-US", className = "" }) {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return null;
  }

  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(Number(value));

  return <span className={className}>{formatted}</span>;
}
